import React from 'react';
import { Droplets } from 'lucide-react';
export function TruthSection() {
  return <section className="py-10 px-4 bg-stone-100" data-id="element-220">
      <div className="max-w-3xl mx-auto" data-id="element-221">
        <h2 className="text-2xl md:text-3xl font-bold text-[#1e3a5f] mb-6 text-center" data-id="element-222">
          La verdad incómoda{' '}
          <span className="text-slate-500 text-xl block mt-1 font-normal" data-id="element-223">
            (pero liberadora)
          </span>
        </h2>

        <div className="text-slate-700" data-id="element-224">
          <p className="mb-4" data-id="element-225">El problema casi nunca es "un gasto grande".</p>
          <div className="bg-white p-5 rounded-xl shadow-sm border border-stone-200 mb-6" data-id="element-226">
            <div className="flex items-start" data-id="element-227">
              <Droplets className="h-7 w-7 text-blue-500 mr-3 flex-shrink-0 mt-1" data-id="element-228" />
              <div data-id="element-229">
                <h3 className="text-lg font-bold text-[#1e3a5f] mb-1" data-id="element-230">
                  El problema es LA FUGA
                </h3>
                <p data-id="element-231">
                  Los gastos pequeños que se repiten y no duelen… hasta que un
                  día duele todo.
                </p>
              </div>
            </div>
          </div>

          <p className="font-bold text-[#1e3a5f] mb-3" data-id="element-232">
            La fuga se alimenta de:
          </p>
          <ul className="space-y-3 mb-6" data-id="element-233">
            {['Compras rápidas para calmar el estrés', "La presión de 'no quiero que a mi hijo le falte'", 'El pago digital (Yape/Plin) que hace el gasto invisible', 'La falta de un momento semanal para corregir'].map((item, idx) => <li key={idx} className="flex items-start bg-white p-2 rounded-lg shadow-sm" data-id="element-234">
                <span className="flex items-center justify-center h-5 w-5 rounded-full bg-red-100 text-[#e63946] font-bold text-xs mr-2 mt-0.5" data-id="element-235">
                  {idx + 1}
                </span>
                <span className="text-sm" data-id="element-236">{item}</span>
              </li>)}
          </ul>

          <p className="text-center font-medium text-base bg-[#fffbf0] p-4 rounded-xl border border-orange-100" data-id="element-237">
            Si tu vida es pesada,{' '}
            <span className="font-bold text-[#e63946]" data-id="element-238">anotar cada gasto</span>{' '}
            no va a salvarte. Porque lo que se rompe no es tu intención. Se
            rompe tu energía.
          </p>
        </div>
      </div>
    </section>;
}